import log from 'helpers/log'

export default (comps) => {
  const c = {}

  const register = () => {
    comps.forEach(comp => {
      const compObj = comp()
      c[compObj.name] = compObj
    })
  }

  const onInit = (config) => {
    Object.keys(c).forEach(compName => {
      const comp = c[compName]
      if(comp.loadCondition()) {
        log.info(`Initializing ${compName} Component`)
        comp.init(config)
      }
    })
  }

  const onResize = (config) => {
    Object.keys(c).forEach(compName => {
      const comp = c[compName]
      if(comp.resize && comp.loadCondition()) {
        comp.resize(config)
      }
    })
  }

  const onReInit = (config) => {
    Object.keys(c).forEach(compName => {
      const comp = c[compName]
      if(comp.reinit && comp.loadCondition()) {
        log.info(`Reinitializing ${compName} Component`)
        comp.reinit(config)
      }
    })
  }

  return { register, onInit, onResize, onReInit }

}



// WEBPACK FOOTER //
// public/content/themes/farrach/src/js/helpers/components.js